module.exports = __webpack_public_path__ + "img/dushi.5e1622c0.jpg";